// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Sentry = require("../../Sentry.bs.js");
var RelayEnv = require("../../../RelayEnv.bs.js");
var DateFnsTz = require("../DateFns/DateFnsTz.bs.js");
var AuthSession = require("../../../utils/AuthSession.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var AvatarSrcUrl = require("../../../utils/AvatarSrcUrl.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var RescriptCore = require("@rescript/core/src/RescriptCore.bs.js");
var LoginListener = require("./LoginListener.bs.js");
var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
var AuthSessionRelay = require("../../../utils/AuthSessionRelay.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var UserSessionQuery_graphql = require("../../../__generated__/UserSessionQuery_graphql.bs.js");
var UserSessionDataQuery_graphql = require("../../../__generated__/UserSessionDataQuery_graphql.bs.js");
var UserSessionAgentInfoQuery_graphql = require("../../../__generated__/UserSessionAgentInfoQuery_graphql.bs.js");
var UserSessionAgentInfo_agent_graphql = require("../../../__generated__/UserSessionAgentInfo_agent_graphql.bs.js");
var UserSessionClientInfoQuery_graphql = require("../../../__generated__/UserSessionClientInfoQuery_graphql.bs.js");
var UserSessionChapterInfoQuery_graphql = require("../../../__generated__/UserSessionChapterInfoQuery_graphql.bs.js");
var UserSessionClientAgentQuery_graphql = require("../../../__generated__/UserSessionClientAgentQuery_graphql.bs.js");
var UserSessionPermissionsQuery_graphql = require("../../../__generated__/UserSessionPermissionsQuery_graphql.bs.js");
var UserSessionClientAgent_agent_graphql = require("../../../__generated__/UserSessionClientAgent_agent_graphql.bs.js");
var UserSessionPlanFeaturesQuery_graphql = require("../../../__generated__/UserSessionPlanFeaturesQuery_graphql.bs.js");
var UserSessionPlansFeatures_plan_graphql = require("../../../__generated__/UserSessionPlansFeatures_plan_graphql.bs.js");
var UserSessionChapterTimezoneQuery_graphql = require("../../../__generated__/UserSessionChapterTimezoneQuery_graphql.bs.js");
var UserSessionUserDisplayInfoQuery_graphql = require("../../../__generated__/UserSessionUserDisplayInfoQuery_graphql.bs.js");
var UserSessionClientInfo_clientInfo_graphql = require("../../../__generated__/UserSessionClientInfo_clientInfo_graphql.bs.js");
var UserSessionChapterInfo_chapterInfo_graphql = require("../../../__generated__/UserSessionChapterInfo_chapterInfo_graphql.bs.js");
var UserSessionChapterPreferencesQuery_graphql = require("../../../__generated__/UserSessionChapterPreferencesQuery_graphql.bs.js");
var UserSessionPermissions_permissions_graphql = require("../../../__generated__/UserSessionPermissions_permissions_graphql.bs.js");
var UserSessionPlanFeatures_planFeatures_graphql = require("../../../__generated__/UserSessionPlanFeatures_planFeatures_graphql.bs.js");
var UserSessionChapterTimezone_chapterTimezone_graphql = require("../../../__generated__/UserSessionChapterTimezone_chapterTimezone_graphql.bs.js");
var UserSessionUserDisplayInfo_userDisplayInfo_graphql = require("../../../__generated__/UserSessionUserDisplayInfo_userDisplayInfo_graphql.bs.js");
var UserSessionChapterPreferences_chapterPreferences_graphql = require("../../../__generated__/UserSessionChapterPreferences_chapterPreferences_graphql.bs.js");

var convertVariables = UserSessionDataQuery_graphql.Internal.convertVariables;

var convertResponse = UserSessionDataQuery_graphql.Internal.convertResponse;

RescriptRelay_Query.useQuery(convertVariables, UserSessionDataQuery_graphql.node, convertResponse);

var useLoader = RescriptRelay_Query.useLoader(convertVariables, UserSessionDataQuery_graphql.node, (function (prim) {
        return prim;
      }));

var usePreloaded = RescriptRelay_Query.usePreloaded(UserSessionDataQuery_graphql.node, convertResponse, (function (prim) {
        return prim;
      }));

RescriptRelay_Query.$$fetch(UserSessionDataQuery_graphql.node, convertResponse, convertVariables);

var fetchPromised = RescriptRelay_Query.fetchPromised(UserSessionDataQuery_graphql.node, convertResponse, convertVariables);

RescriptRelay_Query.retain(UserSessionDataQuery_graphql.node, convertVariables);

var authenticatedStateContext = React.createContext(undefined);

function useForceAuthenticatedState(authType, fnName) {
  var authenticatedState = React.useContext(authenticatedStateContext);
  if (authenticatedState !== authType) {
    return RescriptCore.panic("Calling " + fnName + " can only be done in code that is wrapped in `requireAuthenticatedAgent`. Make sure the page is wrapped in that.");
  }
  
}

var make = authenticatedStateContext.Provider;

var AuthenticatedStateProvider = {
  make: make
};

function useData(queryRef) {
  var authSession = AuthSession.use();
  var authSessionType;
  if (authSession !== undefined) {
    switch (authSession.__typename) {
      case "AuthSession" :
          authSessionType = authSession.user.role === "AGENT" ? "Agent" : "Client";
          break;
      case "AuthSessionUnauthenticated" :
          authSessionType = "Unauthenticated";
          break;
      case "AuthSessionInitializing" :
      case "__unselected" :
          authSessionType = "Other";
          break;
      
    }
  } else {
    authSessionType = "Other";
  }
  var data = usePreloaded(queryRef);
  return React.useMemo((function () {
                var match = data.sessionV5;
                if (authSessionType === "Unauthenticated") {
                  return {
                          TAG: "Ok",
                          _0: "Unauthenticated"
                        };
                }
                if (authSessionType === "Agent") {
                  if (match === undefined) {
                    return {
                            TAG: "Error",
                            _0: "Error decoding session"
                          };
                  }
                  var match$1 = match.authenticatedUserV2;
                  if (match$1.ok !== true) {
                    return {
                            TAG: "Error",
                            _0: "Error decoding session"
                          };
                  }
                  if (match$1.value !== undefined) {
                    return {
                            TAG: "Ok",
                            _0: "Agent"
                          };
                  }
                  
                } else if (authSessionType === "Client") {
                  if (match === undefined) {
                    return {
                            TAG: "Error",
                            _0: "Error decoding session"
                          };
                  }
                  var match$2 = match.authenticatedUserV2;
                  if (match$2.ok !== true) {
                    return {
                            TAG: "Error",
                            _0: "Error decoding session"
                          };
                  }
                  if (match$2.value !== undefined) {
                    return {
                            TAG: "Ok",
                            _0: "Client"
                          };
                  }
                  
                }
                if (match === undefined) {
                  return {
                          TAG: "Error",
                          _0: "Error decoding session"
                        };
                }
                var match$3 = match.authenticatedUserV2;
                if (match$3.ok === true && match$3.value === undefined) {
                  return {
                          TAG: "Ok",
                          _0: "Unauthenticated"
                        };
                } else {
                  return {
                          TAG: "Error",
                          _0: "Error decoding session"
                        };
                }
              }), [
              data,
              authSessionType
            ]);
}

var context = React.createContext("NotCalled");

var make$1 = context.Provider;

var convertVariables$1 = UserSessionQuery_graphql.Internal.convertVariables;

var convertResponse$1 = UserSessionQuery_graphql.Internal.convertResponse;

var use = RescriptRelay_Query.useQuery(convertVariables$1, UserSessionQuery_graphql.node, convertResponse$1);

RescriptRelay_Query.useLoader(convertVariables$1, UserSessionQuery_graphql.node, (function (prim) {
        return prim;
      }));

RescriptRelay_Query.usePreloaded(UserSessionQuery_graphql.node, convertResponse$1, (function (prim) {
        return prim;
      }));

RescriptRelay_Query.$$fetch(UserSessionQuery_graphql.node, convertResponse$1, convertVariables$1);

RescriptRelay_Query.fetchPromised(UserSessionQuery_graphql.node, convertResponse$1, convertVariables$1);

RescriptRelay_Query.retain(UserSessionQuery_graphql.node, convertVariables$1);

function UserSession$Provider$RelaySyncComponent(props) {
  var setValue = props.setValue;
  var data = useData(props.queryRef);
  var match = use(undefined, "store-only", undefined, undefined);
  var currentAuthSession = match.currentAuthSession;
  React.useEffect((function () {
          var exit = 0;
          var exit$1 = 0;
          if (currentAuthSession !== undefined && currentAuthSession.__typename === "AuthSessionUnauthenticated") {
            exit = 1;
          } else {
            exit$1 = 2;
          }
          if (exit$1 === 2) {
            if (data.TAG === "Ok") {
              switch (data._0) {
                case "Unauthenticated" :
                    exit = 1;
                    break;
                case "Agent" :
                    setValue(function (param) {
                          return "Agent";
                        });
                    break;
                case "Client" :
                    setValue(function (param) {
                          return "Client";
                        });
                    break;
                
              }
            } else {
              setValue(function (param) {
                    return "Error";
                  });
            }
          }
          if (exit === 1) {
            setValue(function (param) {
                  return "Unauthenticated";
                });
          }
          
        }), [
        data,
        currentAuthSession
      ]);
  return null;
}

function UserSession$Provider$ComponentRelay(props) {
  var match = React.useState(function () {
        return "NotCalled";
      });
  var setValue = match[1];
  var match$1 = useLoader();
  var loadQuery = match$1[1];
  var queryRef = match$1[0];
  var sessionData = use(undefined, "store-only", undefined, undefined);
  React.useEffect((function () {
          return LoginListener.addListener(function () {
                      setValue(function (param) {
                            return "Loading";
                          });
                    });
        }), []);
  React.useEffect((function () {
          var match = sessionData.currentAuthSession;
          if (match !== undefined) {
            switch (match.__typename) {
              case "AuthSession" :
                  Sentry.addBreadcrumb("Refetching user context", "info", "auth");
                  if (queryRef !== undefined) {
                    fetchPromised(RelayEnv.environment, undefined, undefined, "network-only");
                  } else {
                    setValue(function (param) {
                          return "Loading";
                        });
                    loadQuery(undefined, "network-only", undefined);
                  }
                  break;
              case "AuthSessionInitializing" :
                  setValue(function (param) {
                        return "Loading";
                      });
                  break;
              case "AuthSessionUnauthenticated" :
                  setValue(function (param) {
                        return "Unauthenticated";
                      });
                  break;
              case "__unselected" :
                  break;
              
            }
          }
          
        }), [sessionData]);
  return JsxRuntime.jsxs(make$1, {
              value: match[0],
              children: [
                JsxRuntime.jsx(React.Suspense, {
                      children: Caml_option.some(queryRef !== undefined ? JsxRuntime.jsx(UserSession$Provider$RelaySyncComponent, {
                                  setValue: setValue,
                                  queryRef: Caml_option.valFromOption(queryRef)
                                }) : null),
                      fallback: Caml_option.some(null)
                    }),
                props.children
              ]
            });
}

function UserSession$Provider$WithRelay(props) {
  return JsxRuntime.jsx(RescriptRelay.Context.Provider.make, {
              environment: RelayEnv.environment,
              children: JsxRuntime.jsx(UserSession$Provider$ComponentRelay, {
                    children: props.children
                  })
            });
}

var WithRelay = {
  dummy: AuthSessionRelay.dummy,
  make: UserSession$Provider$WithRelay
};

function useInitState() {
  return React.useContext(context);
}

var convertFragment = UserSessionChapterPreferences_chapterPreferences_graphql.Internal.convertFragment;

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, UserSessionChapterPreferences_chapterPreferences_graphql.node, convertFragment);
}

var convertVariables$2 = UserSessionChapterPreferencesQuery_graphql.Internal.convertVariables;

var convertResponse$2 = UserSessionChapterPreferencesQuery_graphql.Internal.convertResponse;

var use$1 = RescriptRelay_Query.useQuery(convertVariables$2, UserSessionChapterPreferencesQuery_graphql.node, convertResponse$2);

RescriptRelay_Query.useLoader(convertVariables$2, UserSessionChapterPreferencesQuery_graphql.node, (function (prim) {
        return prim;
      }));

RescriptRelay_Query.usePreloaded(UserSessionChapterPreferencesQuery_graphql.node, convertResponse$2, (function (prim) {
        return prim;
      }));

RescriptRelay_Query.$$fetch(UserSessionChapterPreferencesQuery_graphql.node, convertResponse$2, convertVariables$2);

RescriptRelay_Query.fetchPromised(UserSessionChapterPreferencesQuery_graphql.node, convertResponse$2, convertVariables$2);

RescriptRelay_Query.retain(UserSessionChapterPreferencesQuery_graphql.node, convertVariables$2);

function defaultToOff(opt) {
  if (opt !== undefined && (opt === "OFF" || opt === "ON") && opt !== "OFF") {
    return "ON";
  } else {
    return "OFF";
  }
}

function useChapterPreference(preference) {
  useForceAuthenticatedState("Agent", "useChapterPreference");
  var data = use$1(undefined, "store-only", undefined, undefined);
  var match = data.sessionV5;
  var tmp;
  if (match !== undefined) {
    var match$1 = match.authenticatedUserV2;
    if (match$1.ok === true) {
      var match$2 = match$1.value;
      tmp = match$2 !== undefined && match$2.__typename === "Agent" ? Caml_option.some(match$2.fragmentRefs) : undefined;
    } else {
      tmp = undefined;
    }
  } else {
    tmp = undefined;
  }
  var agent = useOpt(tmp);
  var preferences;
  if (agent !== undefined && agent.ok === true) {
    var preferences$1 = agent.value.defaultChapter.preferences;
    preferences = preferences$1 !== undefined ? preferences$1 : undefined;
  } else {
    preferences = undefined;
  }
  if (preferences === undefined) {
    return "OFF";
  }
  switch (preference) {
    case "AnonymousMatching" :
        return defaultToOff(preferences.anonymousMatching);
    case "DefaultToChapterPreferenceAreas" :
        return defaultToOff(preferences.defaultToChapterPreferenceAreas);
    case "GranularNotificationSettings" :
        return defaultToOff(preferences.granularNotificationSettings);
    case "HideChapterStats" :
        return defaultToOff(preferences.hideChapterStats);
    case "ImprovedLocations" :
        return defaultToOff(preferences.improvedLocations);
    case "MlsComingSoon" :
        return defaultToOff(preferences.mlsComingSoon);
    case "PayingChapter" :
        return defaultToOff(preferences.payingChapter);
    case "CheckPropertyStatusOnMLS" :
        return defaultToOff(preferences.mlsPropertyStatusCheck);
    
  }
}

var convertFragment$1 = UserSessionChapterTimezone_chapterTimezone_graphql.Internal.convertFragment;

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, UserSessionChapterTimezone_chapterTimezone_graphql.node, convertFragment$1);
}

var convertVariables$3 = UserSessionChapterTimezoneQuery_graphql.Internal.convertVariables;

var convertResponse$3 = UserSessionChapterTimezoneQuery_graphql.Internal.convertResponse;

var use$2 = RescriptRelay_Query.useQuery(convertVariables$3, UserSessionChapterTimezoneQuery_graphql.node, convertResponse$3);

RescriptRelay_Query.useLoader(convertVariables$3, UserSessionChapterTimezoneQuery_graphql.node, (function (prim) {
        return prim;
      }));

RescriptRelay_Query.usePreloaded(UserSessionChapterTimezoneQuery_graphql.node, convertResponse$3, (function (prim) {
        return prim;
      }));

RescriptRelay_Query.$$fetch(UserSessionChapterTimezoneQuery_graphql.node, convertResponse$3, convertVariables$3);

RescriptRelay_Query.fetchPromised(UserSessionChapterTimezoneQuery_graphql.node, convertResponse$3, convertVariables$3);

RescriptRelay_Query.retain(UserSessionChapterTimezoneQuery_graphql.node, convertVariables$3);

function useChapterTimezone() {
  useForceAuthenticatedState("Agent", "useChapterTimezone");
  var data = use$2(undefined, "store-only", undefined, undefined);
  var match = data.sessionV5;
  var tmp;
  if (match !== undefined) {
    var match$1 = match.authenticatedUserV2;
    if (match$1.ok === true) {
      var match$2 = match$1.value;
      tmp = match$2 !== undefined && match$2.__typename === "Agent" ? Caml_option.some(match$2.fragmentRefs) : undefined;
    } else {
      tmp = undefined;
    }
  } else {
    tmp = undefined;
  }
  var agent = useOpt$1(tmp);
  if (agent === undefined) {
    return RescriptCore.panic("No agent.");
  }
  if (agent.ok !== true) {
    return RescriptCore.panic("No agent.");
  }
  var timezone = agent.value.defaultChapter.timezone;
  if (timezone !== undefined) {
    return DateFnsTz.Timezone.make(timezone);
  } else {
    return RescriptCore.panic("No agent.");
  }
}

var convertFragment$2 = UserSessionChapterInfo_chapterInfo_graphql.Internal.convertFragment;

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, UserSessionChapterInfo_chapterInfo_graphql.node, convertFragment$2);
}

var convertVariables$4 = UserSessionChapterInfoQuery_graphql.Internal.convertVariables;

var convertResponse$4 = UserSessionChapterInfoQuery_graphql.Internal.convertResponse;

var use$3 = RescriptRelay_Query.useQuery(convertVariables$4, UserSessionChapterInfoQuery_graphql.node, convertResponse$4);

RescriptRelay_Query.useLoader(convertVariables$4, UserSessionChapterInfoQuery_graphql.node, (function (prim) {
        return prim;
      }));

RescriptRelay_Query.usePreloaded(UserSessionChapterInfoQuery_graphql.node, convertResponse$4, (function (prim) {
        return prim;
      }));

RescriptRelay_Query.$$fetch(UserSessionChapterInfoQuery_graphql.node, convertResponse$4, convertVariables$4);

RescriptRelay_Query.fetchPromised(UserSessionChapterInfoQuery_graphql.node, convertResponse$4, convertVariables$4);

RescriptRelay_Query.retain(UserSessionChapterInfoQuery_graphql.node, convertVariables$4);

var Chapter = {};

function useChapterInfoOpt() {
  var data = use$3(undefined, "store-only", undefined, undefined);
  var match = data.sessionV5;
  var tmp;
  if (match !== undefined) {
    var match$1 = match.authenticatedUserV2;
    if (match$1.ok === true) {
      var match$2 = match$1.value;
      tmp = match$2 !== undefined && match$2.__typename === "Agent" ? Caml_option.some(match$2.fragmentRefs) : undefined;
    } else {
      tmp = undefined;
    }
  } else {
    tmp = undefined;
  }
  var agent = useOpt$2(tmp);
  if (agent !== undefined && agent.ok === true) {
    return agent.value.defaultChapter;
  }
  
}

function useChapterInfo() {
  useForceAuthenticatedState("Agent", "useChapterInfo");
  return Core__Option.getExn(useChapterInfoOpt(), "Not an agent.");
}

var convertFragment$3 = UserSessionAgentInfo_agent_graphql.Internal.convertFragment;

function useOpt$3(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, UserSessionAgentInfo_agent_graphql.node, convertFragment$3);
}

var convertVariables$5 = UserSessionAgentInfoQuery_graphql.Internal.convertVariables;

var convertResponse$5 = UserSessionAgentInfoQuery_graphql.Internal.convertResponse;

var use$4 = RescriptRelay_Query.useQuery(convertVariables$5, UserSessionAgentInfoQuery_graphql.node, convertResponse$5);

RescriptRelay_Query.useLoader(convertVariables$5, UserSessionAgentInfoQuery_graphql.node, (function (prim) {
        return prim;
      }));

RescriptRelay_Query.usePreloaded(UserSessionAgentInfoQuery_graphql.node, convertResponse$5, (function (prim) {
        return prim;
      }));

RescriptRelay_Query.$$fetch(UserSessionAgentInfoQuery_graphql.node, convertResponse$5, convertVariables$5);

RescriptRelay_Query.fetchPromised(UserSessionAgentInfoQuery_graphql.node, convertResponse$5, convertVariables$5);

RescriptRelay_Query.retain(UserSessionAgentInfoQuery_graphql.node, convertVariables$5);

function avatarUrl(v, width, height) {
  return AvatarSrcUrl.from_key(width, height, Core__Option.map(v.profilePhoto, (function (a) {
                    return a.key;
                  })));
}

function name(v) {
  return v.firstName + " " + v.lastName;
}

var Agent = {
  avatarUrl: avatarUrl,
  name: name
};

function useAgentInfoOpt() {
  var data = use$4(undefined, "store-only", undefined, undefined);
  var match = data.sessionV5;
  var tmp;
  if (match !== undefined) {
    var match$1 = match.authenticatedUserV2;
    if (match$1.ok === true) {
      var match$2 = match$1.value;
      tmp = match$2 !== undefined && match$2.__typename === "Agent" ? Caml_option.some(match$2.fragmentRefs) : undefined;
    } else {
      tmp = undefined;
    }
  } else {
    tmp = undefined;
  }
  var agent = useOpt$3(tmp);
  if (agent !== undefined && agent.ok === true) {
    return agent.value;
  }
  
}

function useAgentInfo() {
  useForceAuthenticatedState("Agent", "useAgentInfo");
  var agentInfo = useAgentInfoOpt();
  return Core__Option.getExn(agentInfo, "Not an agent.");
}

var convertFragment$4 = UserSessionClientInfo_clientInfo_graphql.Internal.convertFragment;

function useOpt$4(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, UserSessionClientInfo_clientInfo_graphql.node, convertFragment$4);
}

var convertVariables$6 = UserSessionClientInfoQuery_graphql.Internal.convertVariables;

var convertResponse$6 = UserSessionClientInfoQuery_graphql.Internal.convertResponse;

var use$5 = RescriptRelay_Query.useQuery(convertVariables$6, UserSessionClientInfoQuery_graphql.node, convertResponse$6);

RescriptRelay_Query.useLoader(convertVariables$6, UserSessionClientInfoQuery_graphql.node, (function (prim) {
        return prim;
      }));

RescriptRelay_Query.usePreloaded(UserSessionClientInfoQuery_graphql.node, convertResponse$6, (function (prim) {
        return prim;
      }));

RescriptRelay_Query.$$fetch(UserSessionClientInfoQuery_graphql.node, convertResponse$6, convertVariables$6);

RescriptRelay_Query.fetchPromised(UserSessionClientInfoQuery_graphql.node, convertResponse$6, convertVariables$6);

RescriptRelay_Query.retain(UserSessionClientInfoQuery_graphql.node, convertVariables$6);

var Agent$1 = {};

var Client = {
  Agent: Agent$1
};

function useClientInfoOpt() {
  var data = use$5(undefined, "store-only", undefined, undefined);
  var match = data.sessionV5;
  var tmp;
  if (match !== undefined) {
    var match$1 = match.authenticatedUserV2;
    if (match$1.ok === true) {
      var match$2 = match$1.value;
      tmp = match$2 !== undefined && match$2.__typename === "RegisteredClient" ? Caml_option.some(match$2.fragmentRefs) : undefined;
    } else {
      tmp = undefined;
    }
  } else {
    tmp = undefined;
  }
  var client = useOpt$4(tmp);
  if (client !== undefined && client.ok === true) {
    return client.value;
  }
  
}

function useClientInfo() {
  useForceAuthenticatedState("Client", "useClientInfo");
  return Core__Option.getExn(useClientInfoOpt(), "Not a client.");
}

var convertFragment$5 = UserSessionUserDisplayInfo_userDisplayInfo_graphql.Internal.convertFragment;

function useOpt$5(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, UserSessionUserDisplayInfo_userDisplayInfo_graphql.node, convertFragment$5);
}

var convertVariables$7 = UserSessionUserDisplayInfoQuery_graphql.Internal.convertVariables;

var convertResponse$7 = UserSessionUserDisplayInfoQuery_graphql.Internal.convertResponse;

var use$6 = RescriptRelay_Query.useQuery(convertVariables$7, UserSessionUserDisplayInfoQuery_graphql.node, convertResponse$7);

RescriptRelay_Query.useLoader(convertVariables$7, UserSessionUserDisplayInfoQuery_graphql.node, (function (prim) {
        return prim;
      }));

RescriptRelay_Query.usePreloaded(UserSessionUserDisplayInfoQuery_graphql.node, convertResponse$7, (function (prim) {
        return prim;
      }));

RescriptRelay_Query.$$fetch(UserSessionUserDisplayInfoQuery_graphql.node, convertResponse$7, convertVariables$7);

RescriptRelay_Query.fetchPromised(UserSessionUserDisplayInfoQuery_graphql.node, convertResponse$7, convertVariables$7);

RescriptRelay_Query.retain(UserSessionUserDisplayInfoQuery_graphql.node, convertVariables$7);

function useCurrentUserInfo() {
  var data = use$6(undefined, "store-only", undefined, undefined);
  var match = data.sessionV5;
  var tmp;
  if (match !== undefined) {
    var match$1 = match.authenticatedUserV2;
    if (match$1.ok === true) {
      var match$2 = match$1.value;
      tmp = match$2 !== undefined ? Caml_option.some(match$2.userDisplayInfo) : undefined;
    } else {
      tmp = undefined;
    }
  } else {
    tmp = undefined;
  }
  var userInfo = useOpt$5(tmp);
  if (userInfo !== undefined && userInfo.ok === true) {
    return userInfo.value.data;
  }
  
}

var convertFragment$6 = UserSessionClientAgent_agent_graphql.Internal.convertFragment;

function useOpt$6(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, UserSessionClientAgent_agent_graphql.node, convertFragment$6);
}

var convertVariables$8 = UserSessionClientAgentQuery_graphql.Internal.convertVariables;

var convertResponse$8 = UserSessionClientAgentQuery_graphql.Internal.convertResponse;

var use$7 = RescriptRelay_Query.useQuery(convertVariables$8, UserSessionClientAgentQuery_graphql.node, convertResponse$8);

RescriptRelay_Query.useLoader(convertVariables$8, UserSessionClientAgentQuery_graphql.node, (function (prim) {
        return prim;
      }));

RescriptRelay_Query.usePreloaded(UserSessionClientAgentQuery_graphql.node, convertResponse$8, (function (prim) {
        return prim;
      }));

RescriptRelay_Query.$$fetch(UserSessionClientAgentQuery_graphql.node, convertResponse$8, convertVariables$8);

RescriptRelay_Query.fetchPromised(UserSessionClientAgentQuery_graphql.node, convertResponse$8, convertVariables$8);

RescriptRelay_Query.retain(UserSessionClientAgentQuery_graphql.node, convertVariables$8);

function useClientAgentOpt() {
  var data = use$7(undefined, "store-only", undefined, undefined);
  var match = data.sessionV5;
  var tmp;
  if (match !== undefined) {
    var match$1 = match.authenticatedUserV2;
    if (match$1.ok === true) {
      var match$2 = match$1.value;
      tmp = match$2 !== undefined && match$2.__typename === "RegisteredClient" ? Caml_option.some(match$2.fragmentRefs) : undefined;
    } else {
      tmp = undefined;
    }
  } else {
    tmp = undefined;
  }
  var client = useOpt$6(tmp);
  if (client !== undefined && client.ok === true) {
    return client.value.agent;
  }
  
}

function useClientAgent() {
  useForceAuthenticatedState("Client", "useClientAgent");
  return Core__Option.getExn(useClientAgentOpt(), "Not a client.");
}

var convertFragment$7 = UserSessionPlansFeatures_plan_graphql.Internal.convertFragment;

function useOpt$7(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, UserSessionPlansFeatures_plan_graphql.node, convertFragment$7);
}

var convertFragment$8 = UserSessionPlanFeatures_planFeatures_graphql.Internal.convertFragment;

function useOpt$8(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, UserSessionPlanFeatures_planFeatures_graphql.node, convertFragment$8);
}

var convertVariables$9 = UserSessionPlanFeaturesQuery_graphql.Internal.convertVariables;

var convertResponse$9 = UserSessionPlanFeaturesQuery_graphql.Internal.convertResponse;

var use$8 = RescriptRelay_Query.useQuery(convertVariables$9, UserSessionPlanFeaturesQuery_graphql.node, convertResponse$9);

RescriptRelay_Query.useLoader(convertVariables$9, UserSessionPlanFeaturesQuery_graphql.node, (function (prim) {
        return prim;
      }));

RescriptRelay_Query.usePreloaded(UserSessionPlanFeaturesQuery_graphql.node, convertResponse$9, (function (prim) {
        return prim;
      }));

RescriptRelay_Query.$$fetch(UserSessionPlanFeaturesQuery_graphql.node, convertResponse$9, convertVariables$9);

RescriptRelay_Query.fetchPromised(UserSessionPlanFeaturesQuery_graphql.node, convertResponse$9, convertVariables$9);

RescriptRelay_Query.retain(UserSessionPlanFeaturesQuery_graphql.node, convertVariables$9);

function isFree(x) {
  var tmp = x.type_;
  if ((tmp === "PRO" || tmp === "FREE" || tmp === "COMPLIMENTARY" || tmp === "PRO_ONLY") && tmp === "FREE") {
    return true;
  } else {
    return false;
  }
}

function isTrial(x) {
  var tmp = x.handle;
  if ((tmp === "PRO_TRIAL" || tmp === "PRO_QUARTERLY" || tmp === "PRO_MONTHLY" || tmp === "PRO_FREE" || tmp === "FREE" || tmp === "COMPLIMENTARY" || tmp === "PRO_YEARLY") && tmp === "PRO_TRIAL") {
    return true;
  } else {
    return false;
  }
}

var Plan = {
  isFree: isFree,
  isTrial: isTrial
};

function usePlan() {
  useForceAuthenticatedState("Agent", "usePlan");
  var data = use$8(undefined, "store-only", undefined, undefined);
  var match = data.sessionV5;
  var tmp;
  if (match !== undefined) {
    var match$1 = match.authenticatedUserV2;
    if (match$1.ok === true) {
      var match$2 = match$1.value;
      tmp = match$2 !== undefined && match$2.__typename === "Agent" ? Caml_option.some(match$2.fragmentRefs) : undefined;
    } else {
      tmp = undefined;
    }
  } else {
    tmp = undefined;
  }
  var agent = useOpt$8(tmp);
  var tmp$1;
  tmp$1 = agent !== undefined && agent.ok === true ? Caml_option.some(agent.value.membership.account.subscription_.plan.fragmentRefs) : undefined;
  var plan = useOpt$7(tmp$1);
  if (plan !== undefined && plan.ok === true) {
    return plan.value;
  } else {
    return RescriptCore.panic("No plan found.");
  }
}

function useHasPlanFeature(feature) {
  useForceAuthenticatedState("Agent", "useHasPlanFeature");
  var data = use$8(undefined, "store-only", undefined, undefined);
  var match = data.sessionV5;
  var tmp;
  if (match !== undefined) {
    var match$1 = match.authenticatedUserV2;
    if (match$1.ok === true) {
      var match$2 = match$1.value;
      tmp = match$2 !== undefined && match$2.__typename === "Agent" ? Caml_option.some(match$2.fragmentRefs) : undefined;
    } else {
      tmp = undefined;
    }
  } else {
    tmp = undefined;
  }
  var agent = useOpt$8(tmp);
  var tmp$1;
  tmp$1 = agent !== undefined && agent.ok === true ? Caml_option.some(agent.value.membership.account.subscription_.plan.fragmentRefs) : undefined;
  var plan = useOpt$7(tmp$1);
  if (plan !== undefined && plan.ok === true) {
    return plan.value.features.includes(feature);
  } else {
    return false;
  }
}

var convertFragment$9 = UserSessionPermissions_permissions_graphql.Internal.convertFragment;

function useOpt$9(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, UserSessionPermissions_permissions_graphql.node, convertFragment$9);
}

var convertVariables$10 = UserSessionPermissionsQuery_graphql.Internal.convertVariables;

var convertResponse$10 = UserSessionPermissionsQuery_graphql.Internal.convertResponse;

var use$9 = RescriptRelay_Query.useQuery(convertVariables$10, UserSessionPermissionsQuery_graphql.node, convertResponse$10);

RescriptRelay_Query.useLoader(convertVariables$10, UserSessionPermissionsQuery_graphql.node, (function (prim) {
        return prim;
      }));

RescriptRelay_Query.usePreloaded(UserSessionPermissionsQuery_graphql.node, convertResponse$10, (function (prim) {
        return prim;
      }));

RescriptRelay_Query.$$fetch(UserSessionPermissionsQuery_graphql.node, convertResponse$10, convertVariables$10);

RescriptRelay_Query.fetchPromised(UserSessionPermissionsQuery_graphql.node, convertResponse$10, convertVariables$10);

RescriptRelay_Query.retain(UserSessionPermissionsQuery_graphql.node, convertVariables$10);

function useHasPermission(permission) {
  useForceAuthenticatedState("Agent", "useHasPermission");
  var data = use$9(undefined, "store-only", undefined, undefined);
  var match = data.sessionV5;
  var tmp;
  if (match !== undefined) {
    var match$1 = match.authenticatedUserV2;
    if (match$1.ok === true) {
      var match$2 = match$1.value;
      tmp = match$2 !== undefined && match$2.__typename === "Agent" ? Caml_option.some(match$2.fragmentRefs) : undefined;
    } else {
      tmp = undefined;
    }
  } else {
    tmp = undefined;
  }
  var agent = useOpt$9(tmp);
  if (agent !== undefined && agent.ok === true) {
    return agent.value.permissions.includes(permission);
  } else {
    return false;
  }
}

function useShouldShowPropertyDetails(propertyAgentId) {
  useForceAuthenticatedState("Agent", "useShouldShowPropertyDetails");
  var agent = useAgentInfoOpt();
  var isPropertyDetailsEnabled = useHasPlanFeature("PROPERTY_DETAILS");
  var isCurrentUser = propertyAgentId !== undefined && agent !== undefined ? propertyAgentId === agent.id : false;
  if (isCurrentUser) {
    return true;
  } else {
    return isPropertyDetailsEnabled;
  }
}

var Provider = {
  WithRelay: WithRelay
};

var provider = UserSession$Provider$WithRelay;

exports.Provider = Provider;
exports.provider = provider;
exports.AuthenticatedStateProvider = AuthenticatedStateProvider;
exports.useInitState = useInitState;
exports.useShouldShowPropertyDetails = useShouldShowPropertyDetails;
exports.Chapter = Chapter;
exports.useChapterPreference = useChapterPreference;
exports.useChapterTimezone = useChapterTimezone;
exports.useChapterInfoOpt = useChapterInfoOpt;
exports.useChapterInfo = useChapterInfo;
exports.Agent = Agent;
exports.useAgentInfoOpt = useAgentInfoOpt;
exports.useAgentInfo = useAgentInfo;
exports.Client = Client;
exports.useClientInfoOpt = useClientInfoOpt;
exports.useClientInfo = useClientInfo;
exports.useClientAgent = useClientAgent;
exports.useCurrentUserInfo = useCurrentUserInfo;
exports.Plan = Plan;
exports.usePlan = usePlan;
exports.useHasPlanFeature = useHasPlanFeature;
exports.useHasPermission = useHasPermission;
/*  Not a pure module */
